import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import FooterComponent from "../footer-component/footerComponent";
import HeaderComponent from "../header-component/headerComponent";
import "./layout.scss";

function Layouts() {
  return (
    <Layout>
      <HeaderComponent></HeaderComponent>
      <Content>
        <Outlet />
      </Content>
      <FooterComponent></FooterComponent>
    </Layout>
  );
}

export default Layouts;
